import { ApiError, ApiResult } from '@models/api';

import { UseQueryOptions, useQuery } from '@hooks/react-query';
import { GetGrabFeatureSettingsResponse } from '../models';

function useRGetGrabFeatureSettings(
  params: {
    featureName: string;
    loandXid?: number;
  },
  options?: UseQueryOptions<
    ApiResult<GetGrabFeatureSettingsResponse>,
    ApiError
  >,
) {
  return useQuery<ApiResult<GetGrabFeatureSettingsResponse>, ApiError>({
    queryKey: [
      'v2/get-grab-feature-setting',
      {
        feature_name: params.featureName,
        ...(params.loandXid && { loan_xid: params.loandXid }),
      },
    ],
    enabled: !!params.featureName,
    ...options,
  });
}

export default useRGetGrabFeatureSettings;
